import { render, staticRenderFns } from "./viewTrip.vue?vue&type=template&id=47aace46&scoped=true&"
import script from "./viewTrip.vue?vue&type=script&lang=js&"
export * from "./viewTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aace46",
  null
  
)

export default component.exports